export default function errorHandler(e: any) {
  console.error(e);
  /**
   * TO DO:
   * identificar o erro
   * enviar para o Google analalytics
   * enviar para o servidor
   * teste de integração
   */
}
